import IntroTooltip from './intro-tooltip/component.vue';
import { mapActions } from 'vuex';

export default {
  name: 'callweb-button',
  props: ['widgetStyle', 'widgetIcon', 'actualHotlineStatus'],
  components: {
    'intro-tooltip': IntroTooltip,
  },
  data() {
    return {
      isButtonVisible: false,
      tooltipShouldShowUp: false,
      hasEntryAnimation: true,
    };
  },
  computed: {
    style() {
      return {
        backgroundColor: this.widgetStyle.main_color,
      };
    },
  },
  created() {
    // opóźnienie dla przycisku CallMeWeb
    const buttonDelay = this.widgetStyle.button_delay * 1000;
    setTimeout(() => {
      this.isButtonVisible = true;
      this.resetEntryDelay();
    }, buttonDelay);
    // opóźenienie dla tooltip
    const tooltipDelay = ((this.widgetStyle.tooltip_delay) + this.widgetStyle.button_delay + 1) * 1000;
    setTimeout(() => { this.tooltipShouldShowUp = true; }, tooltipDelay);
  },
  mounted() {
    if (this.widgetStyle.show_modal_after_leaving_the_window) {
      document.body.addEventListener('mouseleave', (this.triggerWidgetModalVisibility));
    }
  },
  methods: {
    ...mapActions(['toggleWidgetModal', 'resetEntryDelay', 'triggerWidgetModalVisibility']),
    removeEntryAnimation() {
      if (this.hasEntryAnimation) this.hasEntryAnimation = false;
    },
  },
};
